export class ManageGrpEditModel {
    editmodalHeader: string;
    editFieldLabel1: string;
    editPreviousGrpName: string;
    editFieldLabel2: string;
    editButtonMessage: string;
    editcancelButtonMessage: string;
  
    constructor() {}
  }